/**
 * Countries where the free plan is always offered — the one source of truth.
 *
 * Its own leaf module (zero imports) so the CloudFront edge bundle can
 * deep-import it without the api-contract barrel, like
 * `public-doc-category-slugs`. The edge stamps the cache key from this list
 * and SSR renders from it; if they drift, CloudFront files the page under the
 * wrong bucket.
 */
export const FREE_PLAN_COUNTRY_CODES = ['IN', 'PH'] as const;
